var _symbol, _symbol2, _symbol3, _symbol4, _use;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlayground(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 130 180",
    viewBox: "0 0 130 180",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _symbol || (_symbol = /*#__PURE__*/React.createElement("symbol", {
    id: "ac",
    viewBox: "-0.5 -181.95 100.4 169.3"
  }, /*#__PURE__*/React.createElement("use", {
    x: -0.5,
    y: -181.95,
    width: 100.4,
    height: 169.3,
    xlinkHref: "#ad"
  }))), _symbol2 || (_symbol2 = /*#__PURE__*/React.createElement("symbol", {
    id: "ad",
    viewBox: "-0.5 -181.95 100.4 169.3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m64.8-32.15c6.5-0.067 12.8 0.167 18.9 0.7 3.466 0.1 5.367 1.95 5.7 5.55v-7.25h-24.6v1zm-14.6-22.1l-0.9-0.9h-6.3v0.5l7.2 0.4zm28.8-26.45v-1.7h-9.05v0.55c1.833-0.3 4.25-0.316 7.25-0.05l0.25 0.2c0.9-0.167 1.417 0.167 1.55 1zm-35.85-65.25h-9c2.367 0.167 4.367 0.617 6 1.35 1.7 0.767 2.7 2.417 3 4.95v-6.3zm8.9-19.45l3.55 0.6c1.267 0.333 2.05 0.966 2.35 1.9v-2.5h-5.9z",
    clipRule: "evenodd",
    fill: "#D2983C",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m89.4-25.85c-0.267-1.3-2.117-2.433-5.55-3.4-3.434-0.933-8.9-1.25-16.4-0.95l0.2 0.05c-1.733 0.467-2.683 1.267-2.85 2.4v6.25h24.6v-4.35zm-30.7-19.6l-6.65-6.9c-0.6-0.1-1.183-0.2-1.75-0.3-2.9-0.467-5.333-0.717-7.3-0.75v7.95h15.7zm11.25-36.05v4h9.05v-0.35c-0.5-1.633-1.133-2.717-1.9-3.25-2.3-0.633-4.683-0.767-7.15-0.4zm-26.8-50.7c-0.2-3.167-0.8-5.983-1.8-8.45-0.833-1.3-2.033-2.367-3.6-3.2-1.933-1.033-3.833-1.717-5.7-2.05v13.7h11.1zm14.55-30.35c-0.3-0.667-0.784-1.15-1.45-1.45-1.733-0.567-3.25-0.767-4.55-0.6v2.05h6z",
    clipRule: "evenodd",
    fill: "#F1B960",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m89.4-25.9c-0.333-3.6-2.233-5.45-5.7-5.55-6.1-0.533-12.4-0.767-18.9-0.7v4.4c0.167-1.133 1.117-1.933 2.85-2.4l-0.2-0.05c7.5-0.3 12.966 0.017 16.4 0.95 3.433 0.967 5.283 2.1 5.55 3.4v-0.05zm-39.15-28.3l-0.05-0.05-7.2-0.4v1.25c1.967 0.033 4.4 0.283 7.3 0.75 0.567 0.1 1.15 0.2 1.75 0.3l-0.65-0.65-1.15-1.2zm28.75-23.65v-2.85c-0.133-0.833-0.65-1.167-1.55-1l-0.25-0.2c-3-0.267-5.417-0.25-7.25 0.05v0.35c2.466-0.367 4.85-0.233 7.15 0.4 0.767 0.533 1.4 1.617 1.9 3.25zm-44.85-68.1h-2.1v0.05c1.867 0.333 3.767 1.017 5.7 2.05 1.567 0.833 2.767 1.9 3.6 3.2 1 2.467 1.6 5.283 1.8 8.45v-7.45c-0.3-2.533-1.3-4.184-3-4.95-1.633-0.73-3.633-1.18-6-1.35zm23.8-16.95c-0.3-0.934-1.083-1.567-2.35-1.9l-3.55-0.6h-0.35v0.8c1.3-0.167 2.816 0.033 4.55 0.6 0.667 0.3 1.15 0.783 1.45 1.45h0.25v-0.35zm-5.6-2l-0.05-0.05h0.05v0.05z",
    clipRule: "evenodd",
    fill: "#E6AD53",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m69.45-46.2l-4.3 3.9v5.95h24.25v-7.15c-0.066-1.467-0.583-2.3-1.55-2.5-0.133-0.033-0.267-0.05-0.4-0.05l-16.2-0.1c-0.133-0.033-0.4-0.067-0.8-0.1-0.267 0.033-0.6 0.05-1 0.05zm-36.2-32.05v18.9h22.25l-0.45-9.35c-0.4-6.966-7.466-10.316-21.2-10.05-0.267 0.133-0.467 0.3-0.6 0.5zm36.3-86.1l-7.15 0.1c-0.7 0.233-1.117 0.9-1.25 2v6.3h8.4v-8.4zm19.9-11.05c-1.5 0.033-2.333 0.617-2.5 1.75v24.3h2.5v-26.05z",
    clipRule: "evenodd",
    fill: "#AFB300",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m70.95-47.55l-1.5 1.35c0.4 0 0.733-0.017 1-0.05 0.4 0.033 0.667 0.067 0.8 0.1l16.2 0.1c0.133 0 0.267 0.017 0.4 0.05 0.967 0.2 1.483 1.033 1.55 2.5v-4.05h-18.45zm-9.8-114.7c0.133-1.1 0.55-1.767 1.25-2l7.15-0.1v-1.1h-8.2l-0.1-0.05-0.1 3.25zm25.8 12.9v-24.3c0.167-1.133 1-1.717 2.5-1.75v-0.45h-3.1v26.5h0.6z",
    clipRule: "evenodd",
    fill: "#898F00",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m79.3-55.15h-0.6c0.1 0.033 0.183 0.05 0.25 0.05 0.066 0 0.15 0.017 0.25 0.05 0.167 0.033 0.333 0.066 0.5 0.1 1.833 0.4 3.617 0.967 5.35 1.7 1.4 0.6 2.5 1.483 3.3 2.65h1.05v-4.55h-10.1zm3.1-55.5c1.5 0.5 2.9 1.566 4.2 3.2 0.633 0.833 1.133 1.684 1.5 2.55v-5.75h-5.7zm-39.65 70.55c0.867-0.867 1.917-1.4 3.15-1.6 0.633-0.1 2.75-0.15 6.35-0.15 2.867 0 4.683 0.033 5.45 0.1 1.5 0.167 2.65 0.467 3.45 0.9v-1.7h-18.4v2.45zm-4.1 3.75h0.7v-18.8h-5.8c1.467 0.3 2.65 1.167 3.55 2.6 0.867 1.367 1.316 2.933 1.35 4.7 0.133 7.2 0.2 10.967 0.2 11.3v0.2zm-5.35-51.8l4.65-0.3c2.566 0 5.333 0.3 8.3 0.9 1.933 0.4 3.6 0.867 5 1.4h2.1v-2.9h-20.05v0.9zm41.85-0.4v-5.6h-10.25c1.567 0.233 3.467 0.417 5.7 0.55 2.2 0.133 3.35 0.533 3.45 1.2 0.367 2.033 0.733 3.317 1.1 3.85zm-25.2-21.3c1.033 0.633 1.833 1.817 2.4 3.55 0.467 2.2 0.8 3.783 1 4.75v-9.1h-3.45l0.05 0.05v0.75zm17.05-0.8c4.667 0.8 7.383 2.283 8.15 4.45v-4.45h-8.15zm-26.35-9.1l15.25 0.85c7.1-0.367 10.983 0.8 11.65 3.5v-4.7h-26.75l-0.15-0.1v0.45zm6.8-12.6v-4.55l0.05 0.05h13.6l0.05-0.05v4.55h0.6v-5l-14.75 0.05-0.15-0.1v5.05h0.6zm22.75-13.6c0.533 0.233 0.966 0.45 1.3 0.65 0.9 0.566 1.55 1.316 1.95 2.25 0.433 1.033 0.8 2.583 1.1 4.65 0.2 1.633 0.3 3.017 0.3 4.15 0 0.767-0.017 1.4-0.05 1.9h1.35v-13.6h-5.95zm-32.85 28.7v-11.35h-5.4v0.55c1.633 0 3 1.716 4.1 5.15 0.367 1.13 0.8 3.02 1.3 5.65zm-3.1-38.4l10.9 0.65c2.367 0.333 3.567 1.05 3.6 2.15v-2.7l-14.5-0.1zm30.9-16.65v-3.55h-4.35c1.967 1.267 3.15 2.117 3.55 2.55 0.3 0.3 0.567 0.63 0.8 1zm5.4 0.25v-3.8h-2.1v1.2c0.5 0.467 1 1.033 1.5 1.7 0.233 0.3 0.433 0.6 0.6 0.9zm7.15-3.8c1.9 1.3 3.283 3.267 4.15 5.9 0.367 1.133 0.617 2.3 0.75 3.5v-9.4h-4.9z",
    clipRule: "evenodd",
    fill: "#B69F85",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m79.2-55.05l-0.95 0.85-0.8 0.7c0.2 0.067 0.4 0.1 0.6 0.1 0.767 0.133 1.567 0.3 2.4 0.5 2.733 0.633 4.65 1.4 5.75 2.3h2.15c-0.8-1.167-1.9-2.05-3.3-2.65-1.733-0.733-3.517-1.3-5.35-1.7-0.167-0.033-0.333-0.067-0.5-0.1zm-0.55-55.3c3.233 1.733 5.583 5.4 7.05 11 1.2 4.633 1.583 9.033 1.15 13.2h1.25v-18.75c-0.367-0.867-0.867-1.717-1.5-2.55-1.3-1.633-2.7-2.7-4.2-3.2h-3.75v0.3zm-35.05 74c0.767-2.033 1.367-3.2 1.8-3.5 0.7-0.4 2.783-0.6 6.25-0.6 3.133 0 5.45 0.15 6.95 0.45 1.133 0.233 1.983 0.567 2.55 1v-1.85c-0.8-0.433-1.95-0.733-3.45-0.9-0.767-0.067-2.583-0.1-5.45-0.1-3.6 0-5.717 0.05-6.35 0.15-1.233 0.2-2.283 0.733-3.15 1.6v3.75h0.85zm-4.95 0v-0.2c0-0.333-0.066-4.1-0.2-11.3-0.034-1.767-0.483-3.333-1.35-4.7-0.9-1.434-2.083-2.3-3.55-2.6h-1.6v2.8c0.367 0 0.767-0.033 1.2-0.1 2.967 0 4.483 2.083 4.55 6.25-0.267 3.8-0.333 7.083-0.2 9.85h1.15zm41.5-22.5c0.4-5.367 0.117-9.083-0.85-11.15-1.2-2.533-3.733-3.8-7.6-3.8-0.1 0-0.667 0.117-1.7 0.35v4.1c0.5-0.333 1.067-0.5 1.7-0.5 2.667 0 4.333 0.917 5 2.75 0.5 1.3 0.767 4.05 0.8 8.25h2.65zm-22.4-34.8c2.967-0.533 6.533-0.25 10.7 0.85 4.133 1.133 5.85 3.35 5.15 6.65h1.55v-2.4c-0.367-0.534-0.733-1.817-1.1-3.85-0.1-0.667-1.25-1.067-3.45-1.2-2.233-0.133-4.133-0.316-5.7-0.55h-7.2l0.05 0.05v0.45zm0-16.6l7.15 0.6c6.4 1.4 9.767 4.967 10.1 10.7h0.15v-7.25c-0.767-2.167-3.483-3.65-8.15-4.45h-9.35l0.1 0.1v0.3zm8.3-33.6c3.434-0.733 5.617 0.783 6.55 4.55 0.033 0.233 0.2 2.55 0.5 6.95h1.7c0.034-0.5 0.05-1.133 0.05-1.9 0-1.133-0.1-2.517-0.3-4.15-0.3-2.067-0.667-3.617-1.1-4.65-0.4-0.934-1.05-1.684-1.95-2.25-0.333-0.2-0.767-0.417-1.3-0.65h-4.15v2.1zm-17.3-9c-0.033-1.1-1.233-1.816-3.6-2.15l-10.9-0.65h-0.95v1.1l9.65 0.65c3.5 0.566 5.433 2 5.8 4.3v-3.25zm16.4-19.45c-0.233-0.367-0.5-0.7-0.8-1-0.4-0.434-1.583-1.284-3.55-2.55h-8.2v0.9c0.6-0.066 1.15-0.1 1.65-0.1 2.133 0 4.117 0.6 5.95 1.8 2.133 1.367 3.033 3.067 2.7 5.1h2.25v-4.15zm17.45 5.85c-0.133-1.2-0.383-2.367-0.75-3.5-0.867-2.633-2.25-4.6-4.15-5.9h-3.25v0.1c2.8 0.533 4.683 2.867 5.65 7 0.1 0.5 0.3 2.767 0.6 6.8h1.9v-4.5z",
    clipRule: "evenodd",
    fill: "#DFC9B0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m83.6-82.3c1.733 0.3 2.733 2.383 3 6.25l-0.15 16.75h1.65v-23h-4.5zm-51.45 53.1c0.133-0.966 1.067-1.617 2.8-1.95l23.8 0.2c1.433-0.133 2.2 0.633 2.3 2.3v-4.5h-28.9v3.95zm0-79.3c0.167-1.133 1.7-1.617 4.6-1.45 3.233 0.233 5.567 0.434 7 0.6 1.6 0.633 2.467 1.783 2.6 3.45v-5.05h-14.2v2.45zm47.8-34.2c0.066-0.9 0.633-1.55 1.7-1.95l5.1 0.1c1.533 0.267 2.417 1.2 2.65 2.8v-4.15h-9.45v3.2zm-28.05-14.7l0.45-0.7c0.833-0.566 2.7-0.65 5.6-0.25v-1.4h-6.05v2.35z",
    clipRule: "evenodd",
    fill: "#167064",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m86.45-59.3l0.15-16.75c-0.267-3.867-1.267-5.95-3-6.25h-1.05v23h3.9zm-25.4 30.65c-0.1-1.667-0.867-2.434-2.3-2.3l-23.8-0.2c-1.733 0.333-2.667 0.983-2.8 1.95v7.7h28.9v-7.15zm-14.7-77.25c-0.133-1.667-1-2.817-2.6-3.45-1.433-0.167-3.767-0.367-7-0.6-2.9-0.167-4.433 0.317-4.6 1.45v14.95h14.2v-12.35zm33.6-36.8v10.35h9.45v-9.4c-0.233-1.6-1.117-2.533-2.65-2.8l-5.1-0.1c-1.067 0.4-1.633 1.05-1.7 1.95zm-22-15.65c-2.9-0.4-4.767-0.316-5.6 0.25l-0.45 0.7v8.05h6.05v-9z",
    clipRule: "evenodd",
    fill: "#2D8673",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "61.05 -28.65 61.05 -21.7 61.65 -20.15 61.75 -20.15 61.75 -33.15 61.05 -33.15",
    clipRule: "evenodd",
    fill: "#505050",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m75.7-51.85l-1.35 1.2 11.85 0.05c-1.1-0.9-3.017-1.667-5.75-2.3-0.833-0.2-1.633-0.367-2.4-0.5-0.2 0-0.4-0.033-0.6-0.1l-1.75 1.65zm11.15-34.3c0.433-4.167 0.05-8.567-1.15-13.2-1.467-5.6-3.817-9.267-7.05-11v24.2h8.2zm-25.7 47.15c-0.566-0.433-1.417-0.767-2.55-1-1.5-0.3-3.817-0.45-6.95-0.45-3.467 0-5.55 0.2-6.25 0.6-0.433 0.3-1.033 1.467-1.8 3.5h17.55v-2.65zm-29.2-13.35v16h5.55c-0.133-2.767-0.067-6.05 0.2-9.85-0.067-4.167-1.583-6.25-4.55-6.25-0.433 0.067-0.833 0.1-1.2 0.1zm19.3-33.8c-1.4-0.533-3.067-1-5-1.4-2.967-0.6-5.733-0.9-8.3-0.9l-4.65 0.3v2h17.95zm26.25 27.3c-0.033-4.2-0.3-6.95-0.8-8.25-0.667-1.833-2.333-2.75-5-2.75-0.633 0-1.2 0.167-1.7 0.5v10.45l-0.05 0.05h7.55zm-3.9-27.3c0.7-3.3-1.017-5.517-5.15-6.65-4.167-1.1-7.733-1.383-10.7-0.85v7.5h15.85zm-23.65-23.7v16.3h3.4v-8c-0.2-0.967-0.533-2.55-1-4.75-0.567-1.73-1.367-2.92-2.4-3.55zm25.05 10.9c-0.333-5.733-3.7-9.3-10.1-10.7l-7.15-0.6v11.3h17.25zm-7.45-16.45c-0.667-2.7-4.55-3.867-11.65-3.5l-15.25-0.85v5h26.9v-0.65zm-20.1-16.95h13.7v-4.55l-0.05 0.05h-13.6l-0.05-0.05v4.55zm-0.6-8.8h14.9v-4.5h-14.9v4.5zm26.25 8.8c-0.3-4.4-0.467-6.717-0.5-6.95-0.934-3.767-3.117-5.284-6.55-4.55v11.5h7.05zm-41.15 4.3v13.3h5.4v-2.5c-0.5-2.633-0.934-4.517-1.3-5.65-1.1-3.43-2.467-5.15-4.1-5.15zm16.8-21.55c-0.367-2.3-2.3-3.733-5.8-4.3l-9.65-0.65v5.2h15.45v-0.25zm12.5-3.2l-0.1-0.05v3.5h8.4v-3.5l-8.3 0.05zm-8.65-22.15v6.8h10.3c0.333-2.033-0.566-3.733-2.7-5.1-1.833-1.2-3.817-1.8-5.95-1.8-0.5 0-1.05 0.03-1.65 0.1zm28.1 13c-0.3-4.033-0.5-6.3-0.6-6.8-0.967-4.133-2.85-6.467-5.65-7v13.8h6.25zm-12.25-12.7v6.5h2.1v-3.9c-0.167-0.3-0.367-0.6-0.6-0.9-0.5-0.67-1-1.23-1.5-1.7z",
    clipRule: "evenodd",
    fill: "#EAD6BE",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m52.05-52.35l6.65 6.9 3.05 3.15v0.15l3.15 0.05 0.25-0.2 4.3-3.9 1.5-1.35 3.4-3.1 1.35-1.2c-0.233-0.2-0.517-0.35-0.85-0.45-0.067-0.034-0.133-0.067-0.2-0.1-0.167-0.033-0.333-0.083-0.5-0.15-0.133-0.034-0.267-0.05-0.4-0.05-0.633-0.066-1.267-0.133-1.9-0.2-0.167 0-0.333-0.017-0.5-0.05-0.367-0.066-0.733-0.083-1.1-0.05h-0.85c-0.467-0.033-0.95-0.05-1.45-0.05h-1c-0.267 0-0.6-0.283-1-0.85l-0.1-0.1-0.15-4h0.85l0.1 0.35v-0.35h2.45v-15.95h-0.15c-0.133-0.1-0.284-0.217-0.45-0.35-0.133-0.1-0.267-0.216-0.4-0.35-0.1-0.1-0.2-0.217-0.3-0.35-0.1-0.1-0.183-0.15-0.25-0.15-0.2-0.133-0.383-0.317-0.55-0.55-0.133-0.1-0.25-0.217-0.35-0.35-0.2-0.1-0.383-0.216-0.55-0.35-0.167 0-0.333-0.05-0.5-0.15-0.333-0.367-0.65-0.6-0.95-0.7-0.167-0.133-0.333-0.25-0.5-0.35-0.1 0-0.2-0.067-0.3-0.2h-0.3c-0.333-0.233-0.667-0.35-1-0.35h-1.05c-0.3 0.133-0.6 0.083-0.9-0.15-0.133-0.133-0.283-0.2-0.45-0.2-0.133 0-0.283-0.05-0.45-0.15h-0.3c-0.233-0.133-0.45-0.2-0.65-0.2-0.133 0-0.283 0.067-0.45 0.2h-0.3c-0.3 0.233-0.583 0.4-0.85 0.5h-0.05l-0.1 19.45-0.05 0.35h4.4c-0.033 0.333-0.05 0.7-0.05 1.1-0.133 2.7-0.35 4.033-0.65 4h-0.65c-0.1-0.033-0.217-0.05-0.35-0.05h-0.3c-0.533 0-1.083-0.017-1.65-0.05h-1.7c-0.3 0-0.583 0.017-0.85 0.05h-0.65c-0.633 0.067-1.25 0.133-1.85 0.2h-1.25l0.65 0.65z",
    clipRule: "evenodd",
    fill: "#FF7270",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "11.65 -22.7 12.25 -173.4 10.55 -174.2 10.55 -22.7",
    clipRule: "evenodd",
    fill: "#E8DFC1",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10.55-174.2l1.7 0.8c2.767 1.633 4.317 2.75 4.65 3.35 0.333 0.633 0.517 0.983 0.55 1.05v146.25h0.9v-151.8h-7.8v0.35z",
    clipRule: "evenodd",
    fill: "#CBC2A1",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12.25-173.4l-0.6 150.7 5.8-0.05v-146.25c-0.034-0.067-0.217-0.417-0.55-1.05-0.333-0.6-1.883-1.72-4.65-3.35z",
    clipRule: "evenodd",
    fill: "#F9EBD9",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m55.5-59.35h0.9l0.2 0.15v-14.7c-0.267-3.467-1.817-5.3-4.65-5.5-3.467-0.2-6.934-0.317-10.4-0.35-3.533-0.033-5.883 0.2-7.05 0.7-0.267 0.1-0.483 0.2-0.65 0.3 13.733-0.267 20.8 3.083 21.2 10.05l0.45 9.35z",
    clipRule: "evenodd",
    fill: "#9FA300",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m56.6-73.9v-8.05h-23.35v3.7c0.133-0.2 0.333-0.367 0.6-0.5 0.167-0.1 0.383-0.2 0.65-0.3 1.167-0.5 3.517-0.733 7.05-0.7 3.467 0.033 6.934 0.15 10.4 0.35 2.833 0.2 4.383 2.033 4.65 5.5z",
    clipRule: "evenodd",
    fill: "#757A00",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m78.25-54.2c-0.567-0.1-1.15-0.167-1.75-0.2h-0.05c-0.6-0.067-1.2-0.083-1.8-0.05h-7.7v-3.45h-0.3v0.35l-0.1-0.35h-0.85l0.15 4 0.1 0.1c0.4 0.566 0.733 0.85 1 0.85h1c0.5 0 0.983 0.017 1.45 0.05h0.85c0.367-0.033 0.733-0.017 1.1 0.05 0.167 0.033 0.333 0.05 0.5 0.05 0.633 0.066 1.267 0.133 1.9 0.2 0.133 0 0.267 0.017 0.4 0.05 0.167 0.066 0.333 0.117 0.5 0.15 0.067 0.033 0.133 0.066 0.2 0.1 0.333 0.1 0.617 0.25 0.85 0.45l1.75-1.65 0.8-0.7zm-9.15-24.55h-0.15c-0.2 0-0.4-0.117-0.6-0.35-0.3-0.1-0.617-0.15-0.95-0.15h-0.35c-0.167-0.133-0.35-0.25-0.55-0.35-0.233-0.133-0.5-0.2-0.8-0.2-0.3-0.1-0.617-0.217-0.95-0.35-0.1 0-0.217-0.05-0.35-0.15h-0.3c-0.1-0.133-0.2-0.2-0.3-0.2-0.333-0.1-0.667-0.15-1-0.15-0.1-0.133-0.183-0.2-0.25-0.2-0.3 0-0.6-0.05-0.9-0.15h-0.75c-0.133 0-0.283-0.067-0.45-0.2h-0.3c-0.333-0.1-0.667-0.216-1-0.35-0.333-0.1-0.667-0.217-1-0.35-0.066 0-0.167-0.05-0.3-0.15h-0.2c-0.2-0.133-0.383-0.2-0.55-0.2v4.2h0.05c0.267-0.1 0.55-0.267 0.85-0.5h0.3c0.167-0.133 0.317-0.2 0.45-0.2 0.2 0 0.417 0.067 0.65 0.2h0.3c0.167 0.1 0.316 0.15 0.45 0.15 0.167 0 0.317 0.066 0.45 0.2 0.3 0.233 0.6 0.284 0.9 0.15h1.05c0.333 0 0.667 0.117 1 0.35h0.3c0.1 0.133 0.2 0.2 0.3 0.2 0.167 0.1 0.333 0.217 0.5 0.35 0.3 0.1 0.617 0.333 0.95 0.7 0.167 0.1 0.333 0.15 0.5 0.15 0.167 0.133 0.35 0.25 0.55 0.35 0.1 0.133 0.217 0.25 0.35 0.35 0.167 0.233 0.35 0.417 0.55 0.55 0.067 0 0.15 0.05 0.25 0.15 0.1 0.133 0.2 0.25 0.3 0.35 0.133 0.133 0.267 0.25 0.4 0.35 0.167 0.133 0.317 0.25 0.45 0.35h0.15v-4.9zm-9.45 23.55v0.7h-0.9c-0.367 0.033-0.75 0.067-1.15 0.1-0.267 0.033-0.55 0.066-0.85 0.1-0.6 0.033-1.217 0.05-1.85 0.05h-4.05c-0.2 0-0.4 0.017-0.6 0.05l1.15 1.2h1.25c0.6-0.067 1.217-0.133 1.85-0.2h0.65c0.267-0.033 0.55-0.05 0.85-0.05h1.7c0.566 0.033 1.117 0.05 1.65 0.05h0.3c0.133 0 0.25 0.017 0.35 0.05h0.65c0.3 0.033 0.517-1.3 0.65-4 0-0.4 0.017-0.767 0.05-1.1h-1.7v3.05z",
    clipRule: "evenodd",
    fill: "#D96B69",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m78.25-54.2l0.95-0.85c-0.1-0.034-0.184-0.05-0.25-0.05-0.067 0-0.15-0.017-0.25-0.05h0.6l0.1-0.1-12.45 0.05v0.75h7.7c0.6-0.033 1.2-0.017 1.8 0.05h0.05c0.6 0.033 1.183 0.1 1.75 0.2zm-21.15-28.05c0.167 0 0.35 0.067 0.55 0.2h0.2c0.133 0.1 0.233 0.15 0.3 0.15 0.333 0.133 0.667 0.25 1 0.35 0.333 0.133 0.667 0.25 1 0.35h0.3c0.167 0.133 0.316 0.2 0.45 0.2h0.75c0.3 0.1 0.6 0.15 0.9 0.15 0.067 0 0.15 0.067 0.25 0.2 0.333 0 0.667 0.05 1 0.15 0.1 0 0.2 0.067 0.3 0.2h0.3c0.133 0.1 0.25 0.15 0.35 0.15 0.333 0.133 0.65 0.25 0.95 0.35 0.3 0 0.566 0.066 0.8 0.2 0.2 0.1 0.383 0.217 0.55 0.35h0.35c0.333 0 0.65 0.05 0.95 0.15 0.2 0.233 0.4 0.35 0.6 0.35h0.15l0.2-4.9-12.3-0.1 0.1 1.5zm-6.9 28l0.05 0.05c0.2-0.033 0.4-0.05 0.6-0.05h4.05c0.633 0 1.25-0.017 1.85-0.05 0.3-0.034 0.583-0.067 0.85-0.1 0.4-0.033 0.783-0.067 1.15-0.1h0.9v-0.7l-10.35 0.05 0.9 0.9z",
    clipRule: "evenodd",
    fill: "#B4504E",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m70-73.45c1.033-0.233 1.6-0.35 1.7-0.35 3.867 0 6.4 1.267 7.6 3.8 0.967 2.067 1.25 5.783 0.85 11.15h0.35l0.05 0.1v-16h-10.55v1.3z",
    clipRule: "evenodd",
    fill: "#CDB69D",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m89.55-123.05c-0.066-2.867-0.8-4.317-2.2-4.35-8.067-0.2-12.7-0.167-13.9 0.1-1.167 0.333-1.784 1.566-1.85 3.7v8.85h17.95v-8.3zm-40.8-52l-13.75-0.1c-1.233 0.1-1.883 0.167-1.95 0.2-0.6 0.367-0.983 1.133-1.15 2.3v12.5h16.85v-14.9z",
    clipRule: "evenodd",
    fill: "#6B7CBD",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m40.8-128.4l17.25 1.6c4.934 0.633 7.483 1.85 7.65 3.65h1.85v-5.45h-26.75v0.2zm41.25-20.95h0.35v-9.7h-7.65c2.267 0.133 4.1 0.917 5.5 2.35 1.267 1.77 1.867 4.22 1.8 7.35z",
    clipRule: "evenodd",
    fill: "#DB823F",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "34.15 -145.95 43.15 -145.95 43.15 -146.55 31.1 -146.55 32.15 -145.95",
    clipRule: "evenodd",
    fill: "#727272",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m65.7-123.15c-0.167-1.8-2.717-3.017-7.65-3.65l-17.25-1.6v5.25h24.9zm9.05-35.9h-0.7v9.7h8c0.067-3.133-0.533-5.583-1.8-7.35-1.4-1.43-3.233-2.22-5.5-2.35z",
    clipRule: "evenodd",
    fill: "#E59558",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m71.6-123.6c0.066-2.133 0.683-3.367 1.85-3.7 1.2-0.267 5.833-0.3 13.9-0.1 1.4 0.033 2.133 1.483 2.2 4.35v-5.55h-18l0.05 0.05v4.95zm-22.85-51.45v-0.8h-16.85v3.2c0.167-1.167 0.55-1.934 1.15-2.3 0.067-0.033 0.717-0.1 1.95-0.2l13.75 0.1z",
    clipRule: "evenodd",
    fill: "#4F60A4",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "translate(20.6 -89.1)",
    y: -37.55,
    width: 7.25,
    height: 37.55,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "t",
    x1: 372.22,
    x2: 374.47,
    y1: -16258,
    y2: -16258,
    gradientTransform: "matrix(-.0111 -.9999 .9998 -.022 16318 -153.36)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0.251,
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0,
    offset: 1
  })), /*#__PURE__*/React.createElement("path", {
    d: "m55.45-168.75h6.65c1.767 0 2.65-1.333 2.65-4v-1.7c-0.067 2.434-0.95 3.65-2.65 3.65h-6.65c-1.667 0-2.534-1.217-2.6-3.65v1.7c0 2.67 0.867 4 2.6 4z",
    clipRule: "evenodd",
    fill: "url(#t)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m88.8-23.7h-24v-11.65h24v11.65zm1.5 1.35l-0.15-0.15v-0.05l0.15 0.2zm-1.5-35.05v4.55l-9.7-0.05 3.55-3.6h-5.15l-12.55 12.55h-2.45l-12.55-12.55h-5.4l8.75 8.75h-9.75v-9.65h15.95l0.95 2.15 0.95-0.9 0.15-28.1h4.2l0.9-1h0.1v1.9h1.6v22h-1.85v3.95h22.3zm-1.25-27.2v23.05l-3.3 0.1v-23.8h5.75l-2.3 0.65h-0.15zm1.25 46h-23.65v-1.35h0.7l9.85-9.85h13.1v11.2zm-48.8 0h-7.2v-18.8h7.2v18.8zm-20.5 13.65l-7.6 0.05v-152.1h7.6v152.05zm23.8-19.85h13.7l4.85 4.85v1.95h-0.1l-0.6-0.6h-17.85v-6.2zm17.85 20.9v0.2h-28.15v-11.65h28.85v13h-0.1l-0.6-1.55zm-27.05-60.35h16.65v0.05l7-0.05v22.85h-2.9l0.05-0.05-20.8-0.15v-22.65zm19.55-11.6h-3.3v-17.1l-0.05-0.05h3.35v17.15zm4.3 7.4v-7.95l-0.05-0.05h17v8h-16.95zm20.55 27v0.15h-6.95v-14.65h9.2v14.5h-2.25zm-44.4-27v-2.9h19.55v2.9h-19.55zm37.45 9.1v-5.9h7.65v1.9h1.55v4h-9.2zm-38.55-16.5v-17.45h13.85v17.45h-13.85zm42.9-38.85h-9.85v-13.65h9.85v13.65zm-4.45 3.8l-0.05-0.05h17.55v13.85h-17.5v-13.8zm-24.15-12.65v-4.5h14.55v4.5h-14.55zm0 8.85v-5.1l0.15 0.1 14.4-0.05v5.05h-14.55zm-5.9 9.2v-5.45h26.1v5.45h-26.1zm33.5 12.5v11.75h-16.95v-11.65l-0.1-0.1h17.05zm-7.4-9.45v5.35h-26.25v-5.45l0.15 0.1h26.1zm12.1-25.85h9.2v13.6h-9.2v-13.6zm-74.35-32.95v164.1h89.35v-164.1h-89.35zm82.3 68.25v24.55h-9.2v-24.55h9.2zm-1.7-38.75v-26.55h3v26.55h-3zm-11.6-12.6v-13.95h7.95v13.95h-7.95zm-9.1-13.95v7.7h-12.25v-7.7h12.25zm-13.1 10.45h6.1v2.85h-6.1v-2.85zm6.1 16.1h-5.9v-10.4h5.9v10.4zm15.7 0v-9.7h8.15v9.7h-8.15zm-3.4-18.85h-2.05v-7.7h2.05v7.7zm-1 12.25h-8.2l0.1-9.6 0.1 0.05h8v9.55zm-8.2 6.6v-3.5l0.1 0.05 8.1-0.05v3.5h-8.2zm-27.15 0v-6.3l15.05 0.1v6.2h-15.05zm-1.35-10.8v-15.75h16.4v15.75h-16.4zm0.15 27.95v-13.75h0.1l-1.05-0.6h11.75v14.35h-10.8zm-0.1 3.65h5.25v13.85h-5.25v-13.85z",
    clipRule: "evenodd",
    fillOpacity: 0.251,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    clipRule: "evenodd",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m90.75-20.35v-12.8h-1.35v11.6l1.35 1.2zm-1.45-16l1.1 0.6h0.35v-11.8h-1.35v11.2h-0.1zm-0.1-14.25l0.7 0.4h0.85v-4.95h-1.35v4.55h-0.2zm1.4-32.35l-2.35 0.65h-0.15v23l2.3 0.95h0.35v-24.6h-0.15zm-2.5-27.7v24.5h2.65v-25.5l-2.4 1h-0.25zm-26.45 74.9h0.1v-0.05l-0.6-0.6v0.05h-0.1l0.6 0.6zm2.9-5.5l1.55-0.85 13.85-13.05h-1.25l-13.95 13-0.2 0.15v0.75zm2.1-41.7l-0.9 1 0.1 26.8h0.9v-27.8h-0.1zm12.9 24.5v-15.9l-0.75 0.65v14.55l0.75 0.7zm0-24.45l-0.6 0.5h0.05v4.9h-0.05l0.45 0.55h0.15v-5.95zm10-45.7v13.85h1.2v-14.45l-1.2 0.6zm-27.8-8.7v4.95h0.8v-5.4l-0.8 0.45zm-0.3-8.35h0.3v4.5h0.8v-5.4h-0.1l-1 0.9zm15.3-0.7l-0.6 0.45v13.55h0.6v-14zm14-0.1l-1.35 0.6v13.5h1.35v-14.1zm-20.2-7.1l-1 0.75v3.45h1v-4.2zm-0.1-12.8l-0.9 0.9v9.5h1v-10.4h-0.1zm12.15-9.45v13.85h0.35v-14.45l-0.3 0.55-0.05 0.05zm8.15-1.35l-1.35 1.3h0.05v26.5h1.3v-27.8zm-8.4 18.1h0.05v9.7h0.55v-10.4l-0.6 0.7z",
    fill: "#505050"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m65-21.5l-0.45 1.1v0.25h26.2v-0.2l-1.35-1.2v0.05h-24.4zm23.1-37.8h-5.55v0.95h7.85l-2.3-0.95zm-55.9 37.8l-1.25 1.35h30.7l-0.6-1.55v0.2h-28.85zm9.75-14.45v0.2h19.7l-0.6-0.6h-18.3v-0.15l-0.8 0.55zm19.8-5.2h2.8v-1h-2.8v1zm-53.35 21h9.95v-2.6l-7.8 0.05-2.15 2.55zm22.65-15.6h8.3v-0.6h-7.4l-0.9 0.6zm0.3-22.6l25 0.05v-1.05h-23.05l-1.95 1zm47.45-0.85h-8.75l-0.6 0.9h-0.05l-0.1 0.05 10.25-0.1v-0.1l-0.75-0.7v-0.05zm-8.55-18.3h-0.15l-0.75 0.5v0.05h10.05l-0.45-0.55h-8.7z",
    fill: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m64.55-20.4v-12.75h26.2v12.8l0.15 0.2-0.15-0.15v0.15h-26.2v-0.25zm28 5.45v-164.8h-86.8v164.8h86.8zm-28-20.8v-0.25l0.6-0.6 11.05-10.95h14.55v11.8h-26.2zm25.35-14.45h-11.05l0.45-0.45 4.55-4.5h6.9v4.95h-0.85zm-7.35-9.1v-23.65h8.2v24.6h-8.2v-0.95zm5.55-26.85h-9.95v-25.6h12.6v25.6h-2.65zm-57.15 66v-13h30.8v13h-30.8zm11.8-22.4h12.25l6.15 6.15 0.6 0.6v0.05h-19.8v-6.8h0.8zm-0.55-2.4h-0.25v-10.2h1.05v0.7l9.05 9 0.5 0.5h-10.35zm24.45-38h0.1v27.8h13.2l-13.85 13.05-1.55 0.85v0.1h-2.8v0.1l-13.95-14.1h12.65v-27.8h6.2zm-48.3-91.6v154.4h-10.05v-157.1h10.05v2.7zm13.6 119.4h7.4v19.4h-8.4v-19.4h1zm24.4-26.8v23.65l-25-0.05h-0.4v-24.55l25.4-0.05v1zm-3-7.1v2.9h-22.4v-4h22.4v1.1zm-4.5-22.7h4.5v18.2h-4.6v-18.2h0.1zm-17.9 0h15.4v18.2h-15.4v-18.2zm48.6 37.4v16l-10.25 0.1 0.1-0.05h-0.1l0.05-16.25h10.2v0.2zm-23-21.1v-0.1h18.6v9.4h-18.6v-9.3zm0-16.3h18.6v12.8h-18.6v-12.8zm22.85 34.8h-10.05v-6h10.2v6h-0.15zm-11.85-43.15v5.35h-27.4v-5.8h27.4v0.45zm3.2-9.15v-0.1h20v14.6h-20v-14.5zm-24.4-8.55v-0.15h16.2v5.6h-16.2v-5.45zm21.2 9.2v5.45h-27.4v-6.2h27.4v0.75zm-5.8-12.55h-15.4v-5.4h16.2v5.4h-0.8zm-29.7 8.95h-1.1v-14.35h12.2v14.35h-11.1zm44.1-0.15h-10.6v-14.2h11.2v14.2h-0.6zm14.6-14.1v14.1h-10.8v-14.2h10.8v0.1zm-59.8 17.1v-0.1l-0.45-0.1 6.85 0.2v14.6h-6.4v-14.6zm0-28h17.8v8h-17.8v-8zm0-19.9h17.8v17.1h-17.8v-17.1zm51.45 27.9h-8.65v-10.6h9.2v10.6h-0.55zm-12.85 0h-9.4v-4.2h10.4v4.2h-1zm0-6.6h-9.4v-10.4h10.4v10.4h-1zm-1.1-12.2h-0.7v-9.1h2.8v9.1h-2.1zm5.3-8.45v-0.65h9.2v15.3h-9.2v-14.65zm-22.6 16.3v-0.25h6.8v11.2h-6.8v-10.95zm0.55-2.25h-0.55v-3.8h6.8v3.8h-6.25zm-0.45-14.7h13.9v9.1h-14v-9.1h0.1zm35.1 1.4v-1.4h4.4v27.9h-4.4v-26.5z",
    fill: "#363636"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "5.75 -14.95 5.75 -179.75 92.55 -179.75 92.55 -14.95 95.35 -14.95 95.35 -181.95 3.75 -181.95 3.75 -14.95",
    fill: "#2B2B2B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m65.3-36.35l-0.75 0.6h25.85l-1.1-0.6h-24zm23.9-14.25l-9.9-0.05-0.45 0.45h11.05l-0.7-0.4zm-46.2 5.05l-0.8 0.6h10.35l-0.5-0.5h-9.05v-0.1z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m88.1-82.3h0.15l2.35-0.65h-8.05v0.65h5.55zm1.45-46.3l1.2-0.6v-0.15h-20v0.1l0.8 0.65h18zm-10.75 17.95h9.55l2.4-1v-0.1h-12.5l0.55 1.1zm-13.05 28.7l0.9-1h-6.2v1h5.3zm-16.9-29.8l0.95 0.95 0.1 0.15h3.45v-1.1h-4.5zm4.5 22.7v-1.1h-22.05l1.75 1.1h20.3zm-4.6-66.5v-1.8h-17.8l2.35 1.6v0.05l-0.05 0.05h0.05l15.45 0.1zm-16.5 44.6h14.1v-0.8h-15.4l1.3 0.8zm1.05 29.1l23.05-0.1v-1l-25.4 0.05 2.35 1.05zm45.5 8.15l0.75-0.65v-0.2h-10.2l0.15 0.1 0.75 0.6v0.1h8.55v0.05zm-21.1-20.45h17.45v-1.4h-18.6v0.1l1.15 1.3zm9.85-34.45v-0.75h-27.4v0.2l0.8 0.55h26.6zm-9.9 17.95h17.5v-1.1h-18.6l1.1 1.1zm11.75 27.7l0.85 0.6v-0.05h8.7l0.6-0.5v-0.05h-10.15zm-29.15-37.6l0.4 0.35 0.15 0.1h26.75v-0.45h-27.3zm21.5-16.75l0.8-0.45v-0.2h-16.2v0.15l0.5 0.4 0.15 0.1 14.75-0.05v0.05zm-14.8-8.35h14.5l1-0.9h-16.1v0.3l0.6 0.6zm29.2-0.25l0.6-0.45v-0.2h-11.2v0.25l0.5 0.45v-0.1h10.1v0.05zm13.25 0.05l1.35-0.6v-0.1h-10.8v0.65h9.45v0.05zm-58.45 16.5l1.15 0.75h5.25v-0.75l-6.85-0.2 0.45 0.1v0.1zm1.1-46.5h16.7v-1.4h-17.8l1.1 1.4zm42.05 16.8h8.25l0.6-0.7v-0.2h-9.2v0.35l0.3 0.5 0.05 0.05zm-12.95 6.2l0.1 0.05 8.3-0.05v0.05l1-0.75h-10.4v0.1l1 0.6zm-0.7-13.5l0.9 0.9h8.2l0.9-0.9h-10zm8-9.5h2.1v-1.4h-2.8v0.1l0.7 1.3zm5.3-0.75l0.7 0.75h8.15v0.05l0.05-0.05 0.3-0.55v-0.85h-9.2v0.65zm17-0.55v-0.1h-4.4v1.4h3.05l1.35-1.3zm-38.85 17.4h6.05v-0.8h-6.8v0.25l0.75 0.55zm-0.2-5.65h6.25v-0.95h-6.8v0.2l0.55 0.55v0.2zm0.95-10.45h12.5v-1.4h-13.9l1.4 1.4z",
    fill: "#727272"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m64.8-33.15h-0.25v12.75l0.45-1.1h-0.2v-11.65zm0.35-3.45l-0.6 0.6v0.25l0.75-0.6h-0.15v-0.25zm13.5-49.55v-24.5h0.15l-0.55-1.1h-0.1v25.6h0.5zm-46.45 64.65h-0.05v-11.65h-1.2v13l1.25-1.35zm10-23.45l0.8-0.6v-9.6h-1.05v10.2h0.25zm0.55 2.4h-0.8v6.6l0.8-0.55v-6.05zm6.55-12.6h-1.5l13.95 14.1v-1.25l-12.45-12.85zm15.25 13.15l0.2-0.15h-0.2v0.15zm-54 19.3v-151.85l-2.25-2.4v156.8h0.1l2.15-2.55zm21.4-13.65v-18.8h-1v19.4h0.1l0.9-0.6zm1.35-23v-22.5l-2.35-1.05v24.55h0.4l1.95-1zm0-29.7h-0.25l-1.75-1.1h-0.35v4h2.35v-2.9zm-1.15-4.5v-17.4h0.1l-1.3-0.8v18.2h1.2zm38.1 34.35v-14.65l-0.75-0.6-0.15-0.1-0.05 16.25h0.15l0.6-0.9h0.2zm-12.5-26.95v-7.95l-0.05-0.05-1.15-1.3v9.3h1.2zm-17.1-34.05l-0.4-0.35h-0.1v5.8h0.5v-5.45zm9.3 26.65v-17.05l-0.05-0.05-0.1-0.15-0.95-0.95h-0.1v18.2h1.2zm7.8-5.4v-11.6l-0.1-0.1-1.1-1.1v12.8h1.2zm12.5 16.6l-0.85-0.6h-0.05v5.95l0.75-0.5h0.15v-4.85zm1.3-46.25l-0.8-0.65v14.5h0.85v-13.8l-0.05-0.05zm-24.7-3.75v-5.05l-0.5-0.4v5.45h0.5zm-5.9 3.75l-0.8-0.55v6h0.65v-5.45h0.15zm5.9-12.55v-4.5h0.1l-0.6-0.6v5.1h0.5zm-14.8 8.95v-13.75h0.1l-1.05-0.6h-0.15v14.35h1.1zm34-0.15v-13.5l-0.5-0.45v13.95h0.5zm-33.95 3.75l-1.15-0.75v14.6h1v-13.85h0.15zm1.2-20.75v-6.3h-0.05l0.05-0.05v-0.05l-2.35-1.6v8h2.35zm40.8-9.7l-0.05-0.05-0.3-0.5v10.25h0.3v-9.7h0.05zm-42.2-1.1v-15.7h0.15l-1.1-1.4v17.1h0.95zm28.55-6.2h-0.3v10.4h1l0.1-9.55 0.1 0.05-0.9-0.9zm0.7 13.5l-1-0.6v4.1h1v-3.5zm12.6-23.75v14.65h0.7v-13.9l-0.7-0.75zm-5.3 0.75l-0.7-1.3v9h0.7v-7.7zm-16.55 26.5v-10.4l-0.75-0.55v10.95h0.75zm-0.2-13.2v-3.05l-0.55-0.55v3.6h0.55zm0.95-13.3l-1.4-1.4h-0.1v9.1h1.45v-7.7h0.05z",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "10.55 -174.55 18.35 -174.55 18.35 -177.25 8.3 -177.25 8.3 -176.95",
    fill: "#3C3C3C"
  })), /*#__PURE__*/React.createElement("use", {
    transform: "translate(21 -83.25)",
    y: -37.55,
    width: 7.25,
    height: 37.55,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "u",
    x1: 93.9,
    x2: 98.3,
    y1: -97.25,
    y2: -97.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.5098,
    offset: 0.0078
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0,
    offset: 0.9882
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "99.55 -12.65 99.9 -12.65 99.9 -181.85 92.3 -181.85 92.6 -17.05 92.6 -16.75 93.05 -17.05",
    clipRule: "evenodd",
    fill: "url(#u)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "v",
    x1: 49.862,
    x2: 49.875,
    y1: -16.201,
    y2: -12.701,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.5098,
    offset: 0.0078
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0,
    offset: 0.9882
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "6.75 -16.6 0.2 -12.65 99.55 -12.65 93.05 -17.05 92.6 -16.75 92.6 -17.05 7.5 -17.05",
    clipRule: "evenodd",
    fill: "url(#v)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "w",
    x1: 16251,
    x2: 16258,
    y1: -16107,
    y2: -16107,
    gradientTransform: "matrix(-1 0 -.00044326 -1 16250 -16204)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.5098,
    offset: 0.0078
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0,
    offset: 0.9882
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "0.2 -12.65 6.75 -16.6 6.7 -181.85 -0.5 -181.85 -0.5 -12.65",
    clipRule: "evenodd",
    fill: "url(#w)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "0.4 -181.95 0.4 -13.05 99.4 -13.05 99.4 -181.85 98.7 -181.85 98.7 -13.55 1.1 -13.55 1.1 -181.95",
    clipRule: "evenodd",
    fill: "#fff",
    fillOpacity: 0.149,
    fillRule: "evenodd"
  }))), _symbol3 || (_symbol3 = /*#__PURE__*/React.createElement("symbol", {
    id: "a",
    clipRule: "evenodd",
    fillRule: "evenodd",
    viewBox: "0 -37.55 7.25 37.55"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "x",
    x1: -1.4854,
    x2: 11.91,
    y1: -6.0244,
    y2: -39.526,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.6314,
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0,
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "7.25 -37.25 0.95 -37.55 0.125 -28.3 6.975 -1.75",
    fill: "url(#x)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "y",
    x1: -0.0249,
    x2: 6.9253,
    y1: -15.3,
    y2: -15.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#422100",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F8055",
    offset: 0.2745
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2B78F",
    offset: 0.5216
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CEAE7D",
    offset: 0.7333
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F401E",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "0 -27.45 3.45 -28.7 6.55 -27.45 6.55 -1.75 6.95 -1.9 6.95 -27.8 4.1 -28.85 3.05 -28.85 0 -27.8",
    fill: "url(#y)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "z",
    x1: -0.1123,
    x2: 6.5127,
    y1: -14.35,
    y2: -14.35,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#422100",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F8055",
    offset: 0.2745
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2B78F",
    offset: 0.5216
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CEAE7D",
    offset: 0.7333
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F401E",
    offset: 1
  })), /*#__PURE__*/React.createElement("path", {
    d: "m6.55-1.75v-25.7l-3.1-1.25-3.45 1.25v25.9l3.3 1.55 3.25-1.55v-0.2zm-3.2 1.1l-2.55-1.25-0.05-24.95 2.7-1.15 2.5 1.15v24.75l-2.6 1.45z",
    fill: "url(#z)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aa",
    x1: 0.75,
    x2: 5.9502,
    y1: -14.325,
    y2: -14.325,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#422100",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F8055",
    offset: 0.2745
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2B78F",
    offset: 0.5216
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CEAE7D",
    offset: 0.7333
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F401E",
    offset: 1
  })), /*#__PURE__*/React.createElement("path", {
    d: "m3.35-0.65l2.6-1.45v-24.75l-2.5-1.15-2.7 1.15 0.05 24.95 2.55 1.25zm0-0.5l-2.1-0.95-0.05-24.6 2.25-1 2 1.1v24.45l-2.1 1z",
    fill: "url(#aa)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ab",
    x1: -3525.7,
    x2: -3478.1,
    y1: -2461.2,
    y2: -2461.2,
    gradientTransform: "matrix(.9641 -.2655 .5446 .8873 4703.7 1244.2)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#422100",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F8055",
    offset: 0.2745
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2B78F",
    offset: 0.5216
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CEAE7D",
    offset: 0.7333
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F401E",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "3.35 -1.15 5.45 -2.15 5.45 -26.6 3.45 -27.7 1.2 -26.7 1.25 -2.1",
    fill: "url(#ab)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "q",
    x1: 1.6973,
    x2: 4.9947,
    y1: -23.733,
    y2: -25.089,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#422100",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F8055",
    offset: 0.2745
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2B78F",
    offset: 0.5216
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CEAE7D",
    offset: 0.7333
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F401E",
    offset: 1
  })), /*#__PURE__*/React.createElement("path", {
    d: "m3.35-22.6c0.467 0 0.883-0.183 1.25-0.55 0.367-0.3 0.55-0.717 0.55-1.25 0-0.467-0.183-0.883-0.55-1.25s-0.783-0.55-1.25-0.55c-0.533 0-0.967 0.184-1.3 0.55-0.3 0.367-0.45 0.783-0.45 1.25 0 0.533 0.15 0.95 0.45 1.25 0.333 0.367 0.767 0.55 1.3 0.55zm0.95-0.9c-0.2 0.233-0.483 0.35-0.85 0.35h-0.1c-0.367 0-0.7-0.117-1-0.35-0.267-0.233-0.4-0.55-0.4-0.95s0.133-0.716 0.4-0.95c0.3-0.3 0.633-0.45 1-0.45h0.1c0.367 0 0.65 0.15 0.85 0.45 0.3 0.233 0.45 0.55 0.45 0.95s-0.15 0.717-0.45 0.95z",
    fill: "url(#q)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m4.3-23.5c0.3-0.233 0.45-0.55 0.45-0.95s-0.15-0.716-0.45-0.95c-0.2-0.3-0.483-0.45-0.85-0.45h-0.1c-0.367 0-0.7 0.15-1 0.45-0.267 0.233-0.4 0.55-0.4 0.95s0.133 0.717 0.4 0.95c0.3 0.233 0.633 0.35 1 0.35h0.1c0.367 0 0.65-0.117 0.85-0.35z",
    fill: "#2F1D00"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "5.375 -9.475 5.35 -9.475 5.35 -9.45",
    fillOpacity: 0.5333
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "r",
    x1: 4.0479,
    x2: 4.9186,
    y1: -16.968,
    y2: -25.169,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.6314,
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0,
    offset: 1
  })), /*#__PURE__*/React.createElement("path", {
    d: "m4.9-5.9l0.35-0.35 0.075-0.7-1.125-16.45c-0.278 0.222-0.536 0.33-0.775 0.325-0.242-8e-3 -0.408-0.033-0.5-0.075-0.086-0.036-0.261-0.153-0.525-0.35l-1.025 16.55c-0.014 0.565 0.128 0.865 0.425 0.9 0.9 0.733 1.933 0.782 3.1 0.15z",
    fill: "url(#r)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3.575-20.1l1.575 13.825c0.075-0.044 0.15-0.094 0.225-0.15l-1.325-13.475c-0.168-0.099-0.326-0.165-0.475-0.2zm-1.875 13.9l1.175-13.825c-0.091 0.039-0.183 0.097-0.275 0.175l-1.2 13.475c0.101 0.066 0.202 0.124 0.3 0.175z",
    fill: "#2F1D00"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "s",
    x1: 16148,
    x2: 16151,
    y1: -16191,
    y2: -16191,
    gradientTransform: "matrix(-1 0 .0125 -1 16355 -16204)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#422100",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F8055",
    offset: 0.2745
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2B78F",
    offset: 0.5216
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CEAE7D",
    offset: 0.7333
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F401E",
    offset: 1
  })), /*#__PURE__*/React.createElement("path", {
    d: "m2.875-20.025l-1.175 13.825c1.205 0.672 2.355 0.647 3.45-0.075l-1.575-13.825c-0.25-0.052-0.484-0.027-0.7 0.075z",
    fill: "url(#s)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m4.25-17.95c-0.137-0.364-0.253-0.514-0.35-0.45-0.833-0.434-1.333-0.15-1.5 0.85l-0.925 10.45 1.075-8.1c0.128-0.912 0.512-1.162 1.15-0.75 0.336-0.28 0.887 2.904 1.65 9.55l0.025-0.025-1.125-11.525z",
    fillOpacity: 0.1647
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2.4-17.55c0.167-1 0.667-1.284 1.5-0.85 0.097-0.064 0.213 0.085 0.35 0.45l-0.2-1.95c-0.167-0.099-0.326-0.166-0.475-0.2-0.25-0.052-0.484-0.027-0.7 0.075-0.091 0.039-0.183 0.097-0.275 0.175l-0.2 2.3z",
    fillOpacity: 0.5333
  }))), _symbol4 || (_symbol4 = /*#__PURE__*/React.createElement("symbol", {
    id: "ae",
    viewBox: "0.5 -186.95 100.4 169.3"
  }, /*#__PURE__*/React.createElement("use", {
    transform: "translate(1 -5)",
    x: -0.5,
    y: -181.95,
    width: 100.4,
    height: 169.3,
    xlinkHref: "#ac"
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    transform: "matrix(1 0 0 -1 14.85 -6.3999)",
    x: 0.5,
    y: -186.95,
    width: 100.4,
    height: 169.3,
    xlinkHref: "#ae"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayground);
export default __webpack_public_path__ + "static/media/Playground.8508e49b2ae86ea8e684e68836596a3b.svg";
export { ForwardRef as ReactComponent };